module.exports = __webpack_public_path__ + "static/img/6.c1c6cf0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/6.png
// module id = HiLq
// module chunks = 0